import { Component } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DocumentsService, SessionService, UtilsService, UxHelperService } from '@shared/services';
import type { TDocument, TResponse } from '@shared/models';

@Component({
    'selector': 'app-documents',
    'templateUrl': './documents.page.html',
    'styleUrls': ['./documents.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class DocumentsPage implements OnInit, OnDestroy {
    private documentsSubscription: any;
    public documents: any = [];

    constructor(
        private router: Router,
        private uxHelperService: UxHelperService, private documentsService: DocumentsService,
        private sessionService: SessionService, private utilsService: UtilsService) {
    }

    public async ngOnInit() {
        // this.documents = await this.documentsService.getAll();
        const observable = this.documentsService.getObservable();
        this.documentsSubscription = observable.subscribe((documents: TDocument[]) => {
            // this.documents = documents.sort((a, b) => (a.documentName > b.documentName && a.domain > b.domain) ? 1 : -1);
            // this.documents = documents.sort((a, b) => (a.documentName > b.documentName) ? 1 : -1);

            // this.documents = documents;     // await this.documentsService.getAll();
            // var o1 = a[3].toLowerCase();
            // var o2 = b[3].toLowerCase();

            // var p1 = a[1].toLowerCase();
            // var p2 = b[1].toLowerCase();

            // if (o1 < o2) return -1;
            // if (o1 > o2) return 1;
            // if (p1 < p2) return -1;
            // if (p1 > p2) return 1;

            this.documents = documents.sort((a, b) => {
                if (a.documentName < b.documentName) return -1;
                if (a.documentName > b.documentName) return 1;
                if (a.domain < b.domain) return -1;
                if (a.domain > b.domain) return 1;
                return 0;
            });
        });
    }

    public ngOnDestroy() {
        this.documentsSubscription.unsubscribe();
    }

    public async confirmDeleteDocument(document: TDocument) {
        const question = 'Are you sure you want to delete: ' + document.uid + '?';
        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            try {
                await this.uxHelperService.showSpinner('Deleting.');
                await this.documentsService.delete(document.uid);
                this.uxHelperService.hideSpinner();
                const msg = 'Success. ' + document.uid + ' ' + 'has been deleted!';
                await this.uxHelperService.showAlert('Important', msg);
            } catch (err) {
                this.uxHelperService.hideSpinner();
                const errorMessage = this.utilsService.extractError(err);
                await this.uxHelperService.showAlert('Error!', errorMessage);
            }
        }
    }

    public onAddDocumentClick(): void {
        this.router.navigateByUrl('/document');
    }

    public onDocumentClick(uid: string): void {
        this.router.navigateByUrl(`/document/${uid}`);
    }
}
// const question = 'Are you sure you want to print this ticket: ' + ticket.passengerName + '?';
// this.uxHelperService.showConfirmationAlert('Confirm Print', question, (response) => {
//     if (response.selection) {
//         this.printTicket(ticket);
//     }
// });
